export default __webpack_public_path__ + "static/media/no-pc.86ac80de.png";